module.exports = __webpack_public_path__ + "static/media/transit_active.49f19fe4.svg";